import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconHelpOutline = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconHelpOutline",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M478-240q21 0 36-14t14-36-14-35-36-15-35 15-15 35 15 36 35 14m2 160q-83 0-156-31t-127-86-85-127-32-156 32-156 85-127 127-85 156-32 156 32 127 85 86 127 31 156-31 156-86 127-127 86-156 31m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93m4-492q25 0 44 16t18 40q0 22-13 39t-31 32q-23 20-40 44t-18 54q0 14 11 24t24 9q15 0 26-10t13-25q4-21 18-37t30-32q23-22 40-48t16-58q0-51-41-83t-97-33q-38 0-72 16t-53 49q-7 12-4 26t13 20q14 8 29 5t25-17q11-15 28-23t34-8"
  })
}));
IconHelpOutline.displayName = 'IconHelpOutline';